import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import { error as errorOverlay, OverlayManager } from '../../overlays';
import {
  bootstrapAction,
  errorAction,
  loadRequestFilter,
  overlayManagerFilter,
} from '../extensions';
import { normalizeErrors } from '../../handlers/error';

export class ErrorOverlayPlugin implements PluginInterface {
  init(context: CastReceiverContext) {
    let overlayManager = new OverlayManager(
      document.getElementById('overlayContainer') as HTMLDivElement
    );
    bootstrapAction.register(async () => {
      overlayManager = await overlayManagerFilter.apply(overlayManager);
    }, 11);

    loadRequestFilter.register(async loadRequest => {
      overlayManager.hideOverlay();
      return loadRequest;
    }, 9);

    errorAction.register(e => {
      const normalizedErrors = normalizeErrors(e);
      const first = normalizedErrors.filter(err => err?.isErrorTypeFatal)[0];
      if (first) {
        overlayManager.showOverlayFor(errorOverlay, first, 24_000);
      }
    });
  }
}
